import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const modalRoot = document.getElementById('modal-root');

export class ManageLabelEntity extends Component {
    constructor(props) {
        super(props);

        this.state = {
            parent: props.parent,
            category: props.parent ? props.parent.label : props.category,
            labels: [],
            loading: true,
            newLabel: '',
            dialogOpen: false,
            shouldReload: false,
            allowChildren: props.allowChildren,
            selectedParent: null,
            clientOnChange: props.onChange,
            labelAddError: ""
        };

        this.handleNewLabelChange = this.handleNewLabelChange.bind(this);
        this.handleNewLabelSubmited = this.handleNewLabelSubmited.bind(this);
        this.handleDialogOpen = this.handleDialogOpen.bind(this);
        this.handleEditChildren = this.handleEditChildren.bind(this);
        this.getLabels = this.getLabels.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.renderModal = this.renderModal.bind(this);
    }

    componentDidMount() {
        this.getLabels();
    }

    async getLabels() {
        this.setState({ loading: true });

        var response;

        if (this.state.parent) {
            response = await fetch('api/contacts/get-label-entities-by-parent?parentId=' + this.state.parent.id);
        } else {
            response = await fetch('api/contacts/get-label-entities?category=' + this.state.category);
        }

        const data = await response.json();

        console.log(data);

        this.setState({ labels: data, loading: false });
    }

    handleNewLabelChange(e) {
        this.setState({ newLabel: e.target.value });
    }

    handleNewLabelSubmited(e) {
        e.preventDefault();
        e.stopPropagation();

        var url = new URL('/api/contacts/add-label-entity', window.location.origin);
        var fetchParams = {
            category: this.state.category,
            newLabel: this.state.newLabel
        };

        if (this.state.parent) {
            fetchParams.parentId = this.state.parent.id;
        }

        url.search = new URLSearchParams(fetchParams).toString();

        this.setState({ labelAddError: '' });

        fetch(url)
            .then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        this.setState({ newLabel: '' });
                        this.getLabels();

                        if (this.state.clientOnChange) {
                            this.state.clientOnChange(data);
                        }
                    });
                } else {
                    console.error("Submission error", response);

                    this.setState({ labelAddError: "There is already a label with this name." });
                }
            })
            .catch(err => {
                console.error(err);
            })
    }

    handleLabelDeleted(id) {
        if (!window.confirm('Are you sure you want to delete?')) {
            return;
        }

        var url = 'api/contacts/delete-label-entity?id=' + id;
        fetch(url).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    console.log("Delete success", data);
                    this.getLabels();
                } else {
                    console.error("Submission error", response);
                }
            })
        });
    }

    handleEditChildren(parent) {
        this.setState({ selectedParent: parent });

        this.handleDialogOpen();
    }

    handleDialogOpen = () => {
        this.setState({ dialogOpen: true });
    };

    handleDialogClose = () => {
        this.setState({ dialogOpen: false, shouldReload: !this.state.shouldReload });
    };

    renderForm() {
        return (
            <form className="form-inline my-4" onSubmit={this.handleNewLabelSubmited}>
                <div className="input-group mb-3">
                    <input id="txtLabel" type="text" className="form-control" aria-label="Label" value={this.state.newLabel} onChange={this.handleNewLabelChange} />
                    <div className="input-group-append">
                        <button className="btn btn-outline-secondary" type="submit">Add</button>
                    </div>
                </div>
                {this.state.labelAddError &&
                    <p className="alert alert-danger">{this.state.labelAddError}</p>
                }
            </form>
        );
    }

    renderTable() {
        return (
            <table className="table">
                <thead>
                    <tr>
                        <th>Label</th>
                        {this.state.children &&
                            <th># Children</th>
                        }
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.labels && this.state.labels.map(label =>
                        <tr key={label.id}>
                            <td>{label.label}</td>
                            {this.state.children &&
                                <td>{this.state.children.length}</td>
                            }
                            <td className="text-right">
                                {this.state.allowChildren &&
                                    <button type="button" className="btn btn-success btn-sm mr-1" title="Add child" onClick={() => this.handleEditChildren(label)}><FontAwesomeIcon icon="plus-square" /></button>
                                }
                                <button type="button" className="btn btn-danger btn-sm" title="Delete" onClick={() => this.handleLabelDeleted(label.id)}><FontAwesomeIcon icon="trash" /></button></td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    renderModal() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={this.handleDialogClose} fullWidth={true} maxWidth="xs" aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    Manage <em>{this.state.selectedParent.label}</em> Children
                            </DialogTitle>
                <DialogContent>
                    <ManageLabelEntity parent={this.state.selectedParent} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ dialogOpen: false })} color="primary">Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p className="alert alert-warning">Loading...</p>
            : this.renderTable();
        return (
            <div>
                {this.renderForm()}
                {contents}
                {this.props.allowChildren && this.state.selectedParent &&
                    <div>
                        <button type="button" className="btn btn-link" onClick={this.handleDialogOpen}>Manage {this.props.title}</button>
                        {ReactDOM.createPortal(this.renderModal(), document.body)}
                    </div>
                }
            </div>
        );
    }
}